import React from 'react'
import Login from '../Components/Login/Login'

const LoginPage = () => {
  return (
    <Login />
  )
}

export default LoginPage